export const buttonsGroup = ({ buttonsCount }) => ({
    display: 'grid',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: 40,
    gridColumnGap: '16px',
    gridTemplateColumns: `repeat(${buttonsCount}, auto)`,
});
